import { createSelector } from 'reselect';
import { ilHomePageBulletinsSelector as baseIlHomePageBulletinsSelector, homepageLastSearchListingCarouselSelector, makeByIdsDictionarySelector } from './common';
import { IBulletin } from 'utils/entities';
import { lastViewedIdsSelector } from './currentUser';


export const ilHomePageBulletinsTotalSelector = createSelector(
  baseIlHomePageBulletinsSelector,
  (bulletinsDomainData) => {
    if (bulletinsDomainData.data && ('totalBulletinsSection1' in bulletinsDomainData.data)) {
      const { totalBulletinsSection1, totalBulletinsSection2, totalBulletinsSection3 } = bulletinsDomainData.data;

      return {
        totalBulletinsSection1: totalBulletinsSection1.total,
        totalBulletinsSection2: totalBulletinsSection2.total,
        totalBulletinsSection3: totalBulletinsSection3.total,
      };
    }

    return null;
  }
);

type LocalBulletin = IBulletin;
const EMPTY_ARRAY: LocalBulletin[] = [];

const NUMBER_OF_BULLETINS_QUERIES = 10;

export const ilHomePageBulletinsSelector = createSelector(
  baseIlHomePageBulletinsSelector,
  (bulletinsDomainData): LocalBulletin[] => {
    if (bulletinsDomainData.data && ('totalBulletinsSection1' in bulletinsDomainData.data)) {
      const { totalBulletinsSection1, totalBulletinsSection2, totalBulletinsSection3, ...bulletins } = bulletinsDomainData.data;
      const allBulletinsResponses = new Array(NUMBER_OF_BULLETINS_QUERIES).fill('bulletin').map((b, i) => b + (i + 1)).map(b => bulletins[b]).filter(Boolean);
      return allBulletinsResponses.reduce((prev, current) => [ ...prev, ...current.poi ], []);
    }
    return EMPTY_ARRAY;
  }
);

export const homepageLastSearchBulletinsSelector = createSelector(
  homepageLastSearchListingCarouselSelector,
  lastViewedIdsSelector,
  (lastSearchBulletins, lastViewedIds) => {
    if (lastSearchBulletins.data && lastSearchBulletins.data.searchPoiV2 && lastSearchBulletins.data.searchPoiV2.poi) {
      const viewedSet = new Set(lastViewedIds.map(el => el.poiId.id));

      const notViewed = [];
      const viewed = [];

      for (const bulletin of lastSearchBulletins.data.searchPoiV2.poi) {
        if (notViewed.length === 4) break;

        if (viewedSet.has(bulletin.id)) {
          viewed.push(bulletin);
        }
        else {
          notViewed.push(bulletin);
        }
      }

      if (notViewed.length === 4) {
        return notViewed;
      }

      return notViewed.concat(viewed).slice(0, 4);
    }
    return [];
  }
);
export const ilHomePageLastSearchBulletinsByIdsSelector = makeByIdsDictionarySelector(homepageLastSearchBulletinsSelector);

export const ilHomePageBulletinsByIdsSelector = makeByIdsDictionarySelector(ilHomePageBulletinsSelector);
